import { ECodeSystemPayment } from "@/types"

export const PAYMENT_METHODS = [
  // {
  //   id: 1,
  //   isSelected: false,
  //   isAvalible: false,
  //   image: "/img/payment-methods/sss-pay.png",
  //   code: ECodeSystemPayment.MONOLITH,
  // },
  // {
  //   id: 2,
  //   isSelected: false,
  //   isAvalible: false,
  //   image: "/img/payment-methods/invoice.png",
  //   code: ECodeSystemPayment.CASHLESS,
  // },
  {
    id: 3,
    isSelected: true,
    isAvalible: true,
    image: "/img/payment-methods/stripe.png",
    code: ECodeSystemPayment.STRIPE,
  },
  // {
  //   id: 4,
  //   isSelected: false,
  //   isAvalible: false,
  //   image: "/img/payment-methods/interac.png",
  //   code: ECodeSystemPayment.INTERAC,
  // },
] as const
